import { ToastOptions } from '@ionic/react';
import { useToast } from './components/useToast';
import { HookOverlayOptions } from '@ionic/react/dist/types/hooks/HookOverlayOptions';
import { useEffect } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';

export class ToastPresenter {
    toast: (options: ToastOptions & HookOverlayOptions) => void = () => {
        throw new Error('called too soon, need to add some buffering to support that use case');
    };
}

export const ToastBinder: React.FC = () => {
    const [showToast] = useToast();
    const presenter = useInstance(ToastPresenter);

    useEffect(() => {
        presenter.toast = showToast;
    }, [presenter, showToast]);

    return null;
};
